import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PageContainer from '../components/PageContainer';
import PageHero from '../components/PageHero';
import usePageTitle from '../hooks/usePageTitle';
import { Search, Heart, Star, MessageCircle, Bell, Shield } from 'lucide-react';

const ForCustomers = ({ user, onLogout }) => {
  const navigate = useNavigate();
  usePageTitle('Für Nutzer');

  return (
    <div className="min-h-screen bg-gradient-to-br bg-[#F4F2F2]">
      <Navbar user={user} onLogout={onLogout} />
      
      {/* Hero Section */}
      <PageHero
        title="Finde die perfekten Dienstleister für dein Event"
        subtitle="EventConnect verbindet dich mit geprüften Event-Dienstleistern in deiner Nähe. Kostenlos, transparent und einfach."
        buttonText="Jetzt Dienstleister suchen"
        buttonOnClick={() => navigate('/search')}
      />
      
      <div className="pb-16">
        <PageContainer size="large">

          {/* Features */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 bg-[#FFF0D1] rounded-lg flex items-center justify-center mb-4">
                <Search className="w-6 h-6 text-[#2B2142]" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Kostenlose Suche</h3>
              <p className="text-gray-600">
                Durchsuche über 16 Kategorien mit hunderten von Event-Dienstleistern völlig kostenlos.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                <Heart className="w-6 h-6 text-red-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Favoriten speichern</h3>
              <p className="text-gray-600">
                Erstelle Listen mit deinen Favoriten und behalte den Überblick über interessante Dienstleister.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mb-4">
                <Star className="w-6 h-6 text-yellow-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Bewertungen lesen</h3>
              <p className="text-gray-600">
                Profitiere von Erfahrungen anderer Kunden und triff informierte Entscheidungen.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                <MessageCircle className="w-6 h-6 text-green-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Direkter Kontakt</h3>
              <p className="text-gray-600">
                Sende unverbindliche Anfragen direkt an die Dienstleister. Schnell und unkompliziert.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                <Bell className="w-6 h-6 text-purple-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Benachrichtigungen</h3>
              <p className="text-gray-600">
                Erhalte Updates zu deinen Anfragen und verpasse keine Antwort von Dienstleistern.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 bg-[#FFF0D1] rounded-lg flex items-center justify-center mb-4">
                <Shield className="w-6 h-6 text-indigo-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Geprüfte Profile</h3>
              <p className="text-gray-600">
                Alle Dienstleister werden überprüft. Deine Sicherheit hat höchste Priorität.
              </p>
            </div>
          </div>

          {/* CTA */}
          <div className="bg-gradient-to-r from-[#2B2142] to-[#3D3158] rounded-3xl p-12 text-center text-white">
            <h2 className="text-3xl font-bold mb-4">Bereit für dein perfektes Event?</h2>
            <p className="text-xl mb-8 opacity-90">
              Starte jetzt deine kostenlose Suche und finde die besten Dienstleister
            </p>
            <button
              onClick={() => navigate('/search')}
              className="px-8 py-4 bg-white text-[#2B2142] hover:bg-gray-100 font-semibold rounded-xl text-lg transition-colors shadow-lg"
            >
              Jetzt starten
            </button>
          </div>
        </PageContainer>
      </div>
      
      <Footer />
    </div>
  );
};

export default ForCustomers;
